import React, { useState } from "react";
import { ReactComponent as Cross } from "../../assets/analyse/Cross.svg";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";

const ColabMenu = ({ menuPos, name, colabMenu, setColabMenu }) => {
  const [newRole, setNewRole] = useState("");
  const [roleSelected, setRoleSelected] = useState(0);
  return (
    <div>
      <div
        className={`h-[400px] w-[350px] bg-white rounded-lg shadow-xl border-[2px] border-gray-500/10`}
        style={{ position: "fixed", left: menuPos.x, top: menuPos.y }}
      >
        <div className="mx-[15px]">
          <div className="mt-[20px] flex justify-between w-full">
            <p className="font-Poppins-SemiBold text-xs">
              Inviter un collaborateur sur les process
            </p>
            <div className="cursor-pointer">
              <Cross
                height={20}
                onClick={() => {
                  setColabMenu(0);
                }}
              />
            </div>
          </div>
          <div className="mt-[5px]">
            <p className="text-xl font-Poppins-SemiBold">"{name}"</p>
          </div>
          <div className="w-full h-[1px] bg-gray-400/40 rounded-full mt-[10px]" />
          <div className="mt-[20px]">
            <p className="font-Poppins-Light text-xs">Adresse email</p>
            <input
              placeholder="nom@company.com"
              className="bg-[#F8FAFB] w-full h-[35px] rounded-lg text-sm pl-[10px] mt-[5px]"
            />
          </div>
          <div className="mt-[20px]">
            <p className="font-Poppins-Light text-xs">Rôle</p>
            <div>
              {colabMenu >= 2 ? (
                <>
                  <div className="bg-white shadow-sm border-[2px] border-gray-500/10 rounded-lg absolute w-[320px] h-[240px] z-50">
                    <div className="mt-[20px] ml-[10px] flex">
                      {newRole === 1 ? (
                        <>
                          <div className="rounded-full w-[20px] h-[20px] border-blue-500 border-[2px] flex items-center justify-center">
                            <div className="rounded-full w-[10px] h-[10px] bg-blue-500" />
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="rounded-full w-[20px] h-[20px] border-black border-[2px] flex items-center justify-center"
                            onClick={() => {
                              setNewRole(1);
                            }}
                          />
                        </>
                      )}
                      <div className="text-xs font-Poppins-Regular ml-[10px]">
                        <p>Editeur</p>
                        <p>Accès en modification à toutes les propriétées</p>
                      </div>
                    </div>
                    <div className="mt-[20px] ml-[10px] flex">
                      {newRole === 2 ? (
                        <>
                          <div className="rounded-full w-[20px] h-[20px] border-blue-500 border-[2px] flex items-center justify-center">
                            <div className="rounded-full w-[10px] h-[10px] bg-blue-500" />
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="rounded-full w-[20px] h-[20px] border-black border-[2px] flex items-center justify-center"
                            onClick={() => {
                              setNewRole(2);
                            }}
                          />
                        </>
                      )}
                      <div className="text-xs font-Poppins-Regular ml-[10px]">
                        <p>Lecteur</p>
                        <p>Accès en lecture à toutes les propriétées</p>
                      </div>
                    </div>
                    <div className="w-full mt-[20px] h-[80px] flex items-center justify-center">
                      <div className="w-[150px] h-full">
                        <button
                          className="bg-mainGreen rounded-lg w-[150px] h-[30px]"
                          onClick={() => {
                            setColabMenu(1);
                            setRoleSelected(newRole);
                          }}
                        >
                          <p className="text-white font-Poppins-SemiBold text-sm">
                            Valider
                          </p>
                        </button>
                        <button
                          className="mt-[20px] w-[150px] h-[30px]"
                          onClick={() => {
                            setColabMenu(1);
                            setNewRole(roleSelected);
                          }}
                        >
                          <p className="text-mainGreen font-Poppins-SemiBold text-sm">
                            Annuler
                          </p>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
            <div
              className="bg-[#F8FAFB] w-full h-[35px] rounded-lg flex justify-between items-center"
              onClick={() => {
                setColabMenu(2);
              }}
            >
              {roleSelected === 0 ? (
                <p className="text-sm pl-[10px] mt-[5px] text-[#A2A3AF]">
                  Sélectioner un rôle
                </p>
              ) : null}
              {roleSelected === 1 ? (
                <p className="text-sm pl-[10px] mt-[5px] text-[#A2A3AF]">
                  Editeur
                </p>
              ) : null}
              {roleSelected === 2 ? (
                <p className="text-sm pl-[10px] mt-[5px] text-[#A2A3AF]">
                  Lecteur
                </p>
              ) : null}
              <div className="border-l-[1px] border-[#A2A3AF] w-[50px] flex items-center justify-center">
                <BackArrow transform="rotate(270)" />
              </div>
            </div>
          </div>
          <div className="w-full h-[100px] flex justify-center items-end">
            <button
              className="bg-mainGreen w-[160px] h-[40px] rounded-lg text-white font-Poppins-SemiBold text-sm"
              onClick={() => {
                setColabMenu(0);
              }}
            >
              Ajouter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColabMenu;
